export default __webpack_public_path__ + "static/media/bcch-foundation-logo.6db4194f.png";